<template>
  <v-card  id="results-row" :loading="loading" flat>
    <Submenu :parentData="name" />
    
    <transition name="slide-x-transition" mode="out-in">
        <keep-alive>
          <component :is="dynamicComponent" @loading="loadingToggle"></component>
        </keep-alive>
      </transition>
  </v-card>
</template>
    
  


<script>
import Submenu from "@/components/Submenu/";
import ClosedTrades from "@/components/ClosedTrades/";
import OpenTrades from "@/components/OpenTrades/";
import DailyResults from "@/components/DailyResults/";
import PoolTimeline from "@/components/PoolTimeline/";
import TradePreparation from "@/components/TradePreparation/";

export default {
  name: "Section2",
  components: {
    ClosedTrades,
    Submenu,
    DailyResults,
    PoolTimeline,
    OpenTrades,
    TradePreparation
  },
  data() {
    return {
      name: "Section2",
      loading: true,
    };
  },
  computed:{
     dynamicComponent() {
      var menuIdx = this.$store.getters.userSubmenus[this.name].selected;
      return this.$store.getters.userSubmenus[this.name].items[menuIdx].component
    }
  },
  methods: {
    loadingToggle(val) {
      this.loading = val;
    },
    mouseOver(){
       //this.$store.dispatch("resetActivity", {section: this.name})
    }
  },
};
</script>


<style scoped>

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.list-enter-active,
.list-leave-active,
.list-move {
    transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
    transition-property: opacity, transform;
}

.list-enter {
    opacity: 0;
    transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
    opacity: 1;
    transform: translateX(0) scaleY(1);
}

.list-leave-active {
    position: absolute;
}

.list-leave-to {
    opacity: 0;
    transform: scaleY(0);
    transform-origin: center top;
}

.trcontainer {
  width: 100%;
  float: left;
}

.padding-main {
  padding: 15px;
}
.trades {
  float: left;
  width: 100%;
}

.trades-head-abs {
  position: absolute;
  top: 0px;
  left: 22px;
}

.trades-card:nth-child(odd) {
  background-color: #333b46;
}

.trades-card:hover {
  background: #232a35;
}

.symbol {
  position: absolute;
  top: 0px;
  font-size: 18px;
}

.trades-card {
  cursor: pointer;
}

.result-card {
  width: 100%;
  float: left;
  background: #2d3540;
  padding: 6px 0 12px 0;
  border-radius: 3px;
  margin-bottom: 15px;
  height: 50px;
}

.result-head {
  padding-left: 8px;
  font-size: 12px;
}

.result-content {
  float: right;
  padding-right: 12px;
  font-size: 12px;
}

.trades-all {
  color: #25a7f9;
  font-size: 12px;
  float: right;
  padding: 8px 12px 10px 8px;
}

#result-pl {
  font-family: "Roboto Condensed", sans-serif;
  font-size: 14px;
}

.trades-menu {
  float: right;
  width: 100%;
  margin-bottom: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.headline {
  font-family: "Roboto", "Roboto Condensed Bold", sans-serif;
  font-size: 16px;
  color: #ffffff;
}
.v-slider {
  height: 3px;
}

.tabs {
  margin-top: 15px;
  padding-right: 15px;
  border-bottom: 1px solid rgba(128, 143, 156, 0.2);
}

.tab {
  color: #808f9c;
  font-family: "Roboto", "Roboto Condensed", sans-serif;
  font-size: 12px;
  cursor: pointer;
  text-transform: none !important;
}
.tab:hover {
  color: white;
}
.settclass {
  color: red;
  font-size: 13px;
  cursor: pointer;
  padding-left: 8px;
  padding-top: 8px;
}

.circle {
  background-color: #808f9c;
  border-radius: 8px;
  min-width: 16px;
  height: 16px;
  padding: 1px 3px 0 3px;
  margin-left: 3px;
}
</style>